import React, { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FormHelpText from './form-helpText';

interface FormInputEmailItem {
  title?: string;
  required?: boolean;
  validation?: string;
  validationMessage?: string;
  helpText?: string;
}

interface FormInputEmailProps {
  item: FormInputEmailItem;
  unique: string;
  submitted: boolean;
}

const FormInputEmail = ({ item, unique, submitted }: FormInputEmailProps) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);

  const validate = (val: string) => {
    const emailRegex = new RegExp(
       
      /(?!.*\.{2})^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i,
    );
    if (item.required && val === '') {
      setError(true);
    } else if (!emailRegex.test(val)) {
      setError(true);
    } else if (item.validation) {
      const regex = new RegExp(item.validation);
      if (!regex.test(val)) {
        setError(true);
      }
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="py-4">
        <InputLabel className="font-normal text-[#42474a] pb-2 tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <TextField
          type="email"
          value={value}
          variant="outlined"
          fullWidth
          onBlur={(e) => validate(e.target.value)}
          onChange={(e) => setValue(e.target.value)}
          id={`form-${unique}`}
          name={unique}
          inputProps={{
            title: `${item.title}${item.required ? ' *' : ''}`,
          }}
          required={item.required}
          aria-describedby={`${unique}-help`}
          aria-labelledby={`${unique}-help`}
          error={error}
          helperText={
            error
              ? item.validationMessage
                ? item.validationMessage
                : `${item.title} is required`
              : ''
          }
          FormHelperTextProps={{
            className: 'mt-1',
          }}
          InputProps={{
            style: {
              backgroundColor: '#ffffff',
              boxShadow: error ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)` : '',
            } as React.CSSProperties,
            endAdornment: (
              <InputAdornment position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value === '' ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            ),
          }}
        />
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormInputEmail;
